import { FieldType } from 'modules/domains';
import { useFieldType } from './useFieldType';

export const useIsGeoLocationFieldType = () => {
  const fieldType = useFieldType();
  return fieldType === FieldType.GEO_LOCATION;
};
